import { getCvAccessToken } from '@carvana/core-auth';

function getAxiosAuthHeader() {
  const cvAccessToken = getCvAccessToken();

  return cvAccessToken
    ? { Authorization: `Bearer ${cvAccessToken}` }
    : undefined;
}

export default getAxiosAuthHeader;
